import { onTurboPageLoad } from "../turboHelper";
import { attachCancelButtonConfirmation } from "../helpers";
import * as Turbo from "@hotwired/turbo";
import { getModel } from "../modelHelper";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import { attachSummernote } from "../summernoteHelper";
import { selectize } from "../selectizeHelper";

onTurboPageLoad("Destinations/CreateOrEdit", () => {
    const model = getModel<IDestinationCreateOrEditModel>();

    const form = $("#editDestinationForm");
    const editorInputs = $(".html-editor");
    attachSummernote(editorInputs);

    formSubmitWithWaitForJobCompletion(
        form,
        $("#submit"),
        model.getJobUrl,
        () => {
            Turbo.clearCache();
            history.back();
        }
    );
    
    selectize($(`#${model.activationCodesInputId}`), {
        plugins: ["remove_button"],
        delimiter: ",",
        persist: false,
        create(input) {
            return {
                value: input,
                text: input
            }
        }
    });
    
    attachCancelButtonConfirmation();
});

interface IDestinationCreateOrEditModel {
    getJobUrl: string;
    activationCodesInputId: string;
}
